import { gql } from '@apollo/client';

export const HUB_DAILY_REVIEW = gql`
  query HubDailyReview($hubId: Long!) {
    hubDailyReview(hubId: $hubId) {
      hubId
      hubName
      reviewDate
      timeZone
      serverNow
      taskCompletion {
        doneCount
        totalCount
        percent
      }
      summary {
        unfinishedTasks
        doUnfinishedTasks
        overdueTasks
        risksUnresolved
        risksInProgress
        risksHandled
        myAssignedDone
        myAssignedTotal
        myAssignedOverdue
        reportsIn
        reportsExpected
        reportPendingWarehouseNames
      }
      warehouses {
        warehouseId
        warehouseName
        severity
        kpis {
          metricKey
          valueText
          rawValue
          dodChangeText
          dodChange
          severity
          trend {
            label
            value
          }
        }
        taskDoneCount
        taskTotalCount
        unfinishedTaskCount
        riskCount
        notFinishedTasks {
          taskId
          taskCode
          title
          status
          priority
          isOverdue
          overdueMinutes
          windowEndAt
          totalCount
        }
        unresolvedPeriodRisks {
          alertId
          alertTypeCode
          source
          metricKey
          metricValueText
          riskTag
          severity
          headline
          contextText
          recommendedAction
          entities {
            entityType
            entityId
            entityName
            primaryValue
            secondaryValue
            dspName
            rate
            stayMinutes
            subEntities {
              entityType
              entityId
              entityName
              primaryValue
              secondaryValue
              dspName
            }
          }
          trend {
            label
            value
          }
          actions {
            actionCode
            label
            style
            targetType
            targetValue
            targetDisplayName
          }
          triggerReason
          baselineMethod
          confidence
          firstDetectedAt
          lastDetectedAt
          consecutiveDays
          resolvedAt
          handleStatus
          handledByName
          handledAt
          actionTaken
          comment {
            content
            byId
            byName
            at
            updatedAt
            canEdit
          }
        }
        risks {
          alertId
          alertTypeCode
          source
          metricKey
          metricValueText
          riskTag
          severity
          headline
          contextText
          recommendedAction
          entities {
            entityType
            entityId
            entityName
            primaryValue
            secondaryValue
            dspName
            rate
            stayMinutes
            subEntities {
              entityType
              entityId
              entityName
              primaryValue
              secondaryValue
              dspName
            }
          }
          trend {
            label
            value
          }
          actions {
            actionCode
            label
            style
            targetType
            targetValue
            targetDisplayName
          }
          triggerReason
          baselineMethod
          confidence
          firstDetectedAt
          lastDetectedAt
          consecutiveDays
          resolvedAt
          handleStatus
          handledByName
          handledAt
          actionTaken
          comment {
            content
            byId
            byName
            at
            updatedAt
            canEdit
          }
        }
        supplementaryNote
      }
      onTrackWarehouses {
        warehouseId
        warehouseName
        unfinishedTaskCount
        risksHandledCount
        taskDoneCount
        taskTotalCount
      }
      calculatedAt
      assignableWarehouses {
        warehouseId
        warehouseName
        timeZone
      }
      reportDeadline
      showLive
      showPeriod
    }
  }
`;
